import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6444656e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "function-navigation" }
const _hoisted_2 = { class: "function-navigation-content" }
const _hoisted_3 = { class: "function-heading" }
const _hoisted_4 = { class: "function-heading-copy" }
const _hoisted_5 = { class: "function-title" }
const _hoisted_6 = { class: "function-description" }
const _hoisted_7 = { class: "function-help-trigger" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "function-heading-tail",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "membership-reminder",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_FunctionHelp = _resolveComponent("FunctionHelp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "back-icon",
        type: "button",
        "aria-label": "返回上一页",
        title: "返回上一页",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
      }, [
        _createVNode(_component_svg_icon, {
          icon: "prev",
          "aria-hidden": "true"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.functionTitle), 1),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.functionDescription) + " ", 1),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("button", {
                  class: "function-video-button",
                  type: "button",
                  "aria-label": "打开功能帮助",
                  title: "打开功能帮助",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.guideHelpVisible = true))
                }, "帮助"),
                _createElementVNode("button", {
                  class: "function-help-question",
                  type: "button",
                  "aria-label": "打开功能帮助",
                  title: "打开功能帮助",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.guideHelpVisible = true))
                }, "?")
              ])
            ])
          ]),
          _hoisted_8
        ]),
        (_ctx.reminderText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.reminderText), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FunctionHelp, {
      visible: _ctx.guideHelpVisible,
      url: _ctx.functionVideoUrl,
      title: _ctx.functionTitle,
      description: _ctx.functionDescription,
      path: _ctx.route.path,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.guideHelpVisible = false))
    }, null, 8, ["visible", "url", "title", "description", "path"])
  ], 64))
}